import React from "react"

export const HeaderComponent = () => {
  return (
    <>
      <tmo-digital-header navstyle="light"></tmo-digital-header>
    </>
  )
}
